import { IconButton } from '@festina-life/ui/actions'
import type { ComponentProps } from 'react'

type Props = {
  isActive: boolean
} & Pick<
  ComponentProps<typeof IconButton>,
  'iconName' | 'onClick' | 'className' | 'iconSize' | 'tip'
>

export const ToggleIconButton = ({
  isActive,
  iconSize = 'md',
  className,
  ...rest
}: Props) => (
  <IconButton
    {...rest}
    iconSize={iconSize}
    variant={isActive ? 'primary' : 'discreet'}
  />
)
